(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    $(document.body).on("click", ".see-more--responsible", function (event) {
      var list = document.getElementsByClassName("more-responsible");
      event.currentTarget.style.display = "none";
      for (i = 0; i < list.length; i++) {
        list[i].style.display = "block";
      }
    });
  });
})(jQuery);